import './App.css';
import HomePage from './screens/homePage/HomePage';
import CoursePage from './screens/coursePage/CoursePage';

function App() {
  return (
    <div className="App">
      <CoursePage/>
    </div>
  );
}

export default App;
